// Låter en sida ge sin egen etikett i brödsmulan, t.ex. anbudets nummer och
// namn i stället för id:t i adressen. Sidan anropar useBrodsmulaEtikett(sökväg,
// etikett); Layout läser etiketterna via useBrodsmulaEtiketter(). 2026-10-13.
import { useEffect, useSyncExternalStore } from 'react';

// Namn för adresser vars sida inte alltid hinner sätta sin egen etikett, till
// exempel när åtkomstsidan visas i stället för sidan och adressen saknar å, ä
// och ö. Layout läser listan efter modulregistret. BL-300 punkt 7.
export const FASTA_ETIKETTER = {
  '/pa-gang/sa-utvecklas-kanplan': 'Så utvecklas KanPlan',
  '/pa-gang/sa-arbetar-vi': 'Så arbetar vi',
};

let etiketter = {};
const lyssnare = new Set();

function meddela() {
  lyssnare.forEach((fn) => fn());
}

function prenumerera(fn) {
  lyssnare.add(fn);
  return () => lyssnare.delete(fn);
}

export function useBrodsmulaEtiketter() {
  return useSyncExternalStore(prenumerera, () => etiketter);
}

export function useBrodsmulaEtikett(sokvag, etikett) {
  useEffect(() => {
    if (!sokvag || !etikett) return undefined;
    etiketter = { ...etiketter, [sokvag]: etikett };
    meddela();
    return () => {
      if (etiketter[sokvag] !== etikett) return;
      const rest = { ...etiketter };
      delete rest[sokvag];
      etiketter = rest;
      meddela();
    };
  }, [sokvag, etikett]);
}
